module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 mt-8"
  }, [_c('div', {
    staticClass: "intro-y flex h-10 justify-between"
  }, [_c('h2', {
    staticClass: "text-lg font-medium truncate mr-5"
  }, [_vm._v("Reporte General")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-2"
  }, [(_vm.emailsdownload.includes(_vm.usersession.email)) ? _c('email-download-list-button', {
    attrs: {
      "classname": 'mr-0 button--sm',
      "text": "Descargar Lista de Cortes"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/admin/hours-tasks'
    }
  }, [_c('button', {
    staticClass: "button button--sm xs:w-10 sm:w-52 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('Icon', {
    attrs: {
      "name": 'file',
      "classname": 'w-4 h-4 sm:mr-2'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Resumen de horas")])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/admin/calendar/' + _vm.usersession.slug
    }
  }, [_c('button', {
    staticClass: "button button--sm xs:w-10 sm:w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('Icon', {
    attrs: {
      "name": 'calendar',
      "classname": 'w-4 h-4 sm:mr-2'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Calendario")])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "w-50",
    attrs: {
      "to": "/admin/platforms"
    }
  }, [_c('button', {
    staticClass: "button button--sm xs:w-10 sm:w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('Icon', {
    attrs: {
      "name": 'globe',
      "classname": 'w-4 h-4 sm:mr-2'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Plataformas")])], 1)])], 1)]), _vm._v(" "), (_vm.usersession) ? _c('p', {
    staticClass: "typing text-md mb-2 hidden sm:block",
    style: ({
      width: 48 + _vm.usersession.name.length + 'ch'
    })
  }, [_vm._v("\n            Bienvenido(a) " + _vm._s(_vm.usersession.nickname) + ", a continuación\n            encontraras el reporte general.\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-5 intro-y"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "text-lg font-medium px-5 py-3 border-b"
  }, [_vm._v("\n                  Generar Contraseñas\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col lg:flex-row items-center p-5"
  }, [(_vm.password) ? _c('div', {
    staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: "input border flex-1 w-64",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Copy', {
    attrs: {
      "text": _vm.password
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "flex mt-1 text-xs"
  }, [_vm._v("\n                      Clic en el icono\n                      "), _c('Icon', {
    attrs: {
      "name": "copy",
      "classname": "w-4 h-4 mx-2 text-gray-500"
    }
  }), _vm._v("\n                      para copiar.\n                    ")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex mt-4 lg:mt-0"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 mr-2 zoom-in",
    on: {
      "click": function($event) {
        return _vm.generatePassword()
      }
    }
  }, [_vm._v("\n                      Generar " + _vm._s(_vm.password != '' ? 'Nueva' : '') + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4 xl:col-span-4 intro-y"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "text-lg font-medium px-5 py-4 border-b"
  }, [_vm._v("Tip")]), _vm._v(" "), (_vm.tip) ? _c('div', {
    staticClass: "flex flex-col lg:flex-row items-center py-3 px-5"
  }, [_c('div', {
    staticClass: "col-span-12 bg-white p-2 text-md"
  }, [_vm._v("\n                    " + _vm._s(_vm.tip.description) + "\n                  ")])]) : _vm._e()])])])])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-789ffab5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/dashboard/DashboardUser.vue
// module id = 462
// module chunks = 1